/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ModelCommonResponse, ModelEditQueryRequest } from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class EditQuery<
  SecurityDataType = unknown
> extends HttpClient<SecurityDataType> {
  /**
   * @description edit query
   *
   * @tags table
   * @name EditQueryCreate
   * @summary edit query
   * @request POST:/editQuery
   */
  editQueryCreate = (
    request: ModelEditQueryRequest,
    params: RequestParams = {}
  ) =>
    this.request<ModelCommonResponse, any>({
      path: `/editQuery`,
      method: 'POST',
      body: request,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
